import React, { useLayoutEffect } from 'react'
import { View } from 'react-native'
import { useSelector } from 'APP/Hooks/redux'
import { useNavigation } from '@react-navigation/native'
import Moment from 'moment'

import Config from 'APP/Config'
import { Format } from 'APP/Lib/ProfileDataFormat'
import NoticeBarContainer from 'APP/Components/NoticeBarContainer'

import Cobranding from 'APP/Components/Cobranding'
import ListItem from 'APP/Converse/ListItem'
import DialogueBranding from 'APP/Components/DialogueBranding'
import List from 'APP/Components/List'

// Styles
import Styles from './style'

// I18n
import I18n from 'APP/I18n'

//Services
import { useServiceFeatures } from 'APP/Hooks/ServiceFeatures'
import { ResponsiveScrollView } from 'APP/Converse/Layout'

const ProfileScreen = () => {
  const navigation = useNavigation()
  const profile = useSelector((state) => state.patient.profile)
  const idCardUrl = useSelector((state) => state.patient.idCardUrl || state.patient.idCardLocalPath)
  const canChangeEmail = useSelector((state) => {
    const customClaims = state.login.customClaims || {}

    return !Config.PROFILE_CHANGE_EMAIL_DISABLED_ON_SSO_CONNECTION?.includes(
      customClaims['sso-connection']
    )
  })
  const serviceFeatures = useServiceFeatures()

  useLayoutEffect(() => {
    navigation.setOptions({
      rightButtonIcon: 'pencil',
      rightButtonIconVariant: 'material',
      rightButtonText: 'Edit',
      rightButtonTitle: I18n.t('ProfileScreen.edit'),
      rightButtonOnPress: () => navigation.navigate('editProfile'),
    })
  })

  return (
    <NoticeBarContainer>
      <ResponsiveScrollView>
        <List containerStyle={Styles.listContainer}>
          <ListItem
            key="givenName"
            analyticsName="givenName"
            testID="PROFILE_SCREEN_FIRST_NAME_FIELD"
            title={I18n.t('ProfileScreen.legalName')}
            rightTitle={profile.givenName}
            hideIconComponent
            tabIndex={0}
          />
          {Boolean(profile.preferredName && profile.preferredName !== '') && (
            <ListItem
              key="preferredName"
              analyticsName="preferredName"
              testID="PROFILE_SCREEN_PREFERRED_NAME_FIELD"
              title={I18n.t('ProfileScreen.preferredName')}
              rightTitle={profile.preferredName}
              hideIconComponent
              tabIndex={0}
            />
          )}
          <ListItem
            key="familyName"
            analyticsName="familyName"
            testID="PROFILE_SCREEN_LAST_NAME_FIELD"
            title={I18n.t('ProfileScreen.familyName')}
            rightTitle={profile.familyName}
            hideIconComponent
            tabIndex={0}
          />
          {Boolean(profile?.pronouns) && (
            <ListItem
              key="pronouns"
              analyticsName="pronouns"
              testID="PROFILE_SCREEN_PRONOUNS_FIELD"
              title={I18n.t('ProfileScreen.pronouns')}
              rightTitle={profile.pronouns}
              hideIconComponent
              tabIndex={0}
            />
          )}
          <ListItem
            key="bday"
            analyticsName="bday"
            testID="PROFILE_SCREEN_DOB_FIELD"
            title={I18n.t('ProfileScreen.bday')}
            rightTitle={Moment(profile.dateOfBirth).format(Format.DISPLAY_DATE)}
            hideIconComponent
            tabIndex={0}
          />
          {profile.genderIdentity && (
            <ListItem
              key="genderIdentity"
              analyticsName="genderIdentity"
              testID="PROFILE_SCREEN_GENDER_IDENTITY_FIELD"
              title={I18n.t('ProfileScreen.genderIdentity')}
              rightTitle={Format.gender(profile.genderIdentity)}
              hideIconComponent
              tabIndex={0}
            />
          )}
          {profile.genderIdentity === 'prefer_to_self_identify' && (
            <ListItem
              key="genderIdentityDescription"
              analyticsName="genderIdentityDescription"
              testID="PROFILE_SCREEN_GENDER_IDENTITY_DESCRIPTION_FIELD"
              title={I18n.t('ProfileScreen.genderIdentityDescription')}
              rightTitle={profile.genderIdentityDescription}
              hideIconComponent
              tabIndex={0}
            />
          )}
          <ListItem
            key="mobile"
            analyticsName="mobile"
            testID="PROFILE_SCREEN_PHONE_NUMBER_FIELD"
            title={I18n.t('ProfileScreen.number')}
            rightTitle={Format.phoneNumber(profile.phoneNumber)}
            hideIconComponent
            tabIndex={0}
          />
          <ListItem
            key="language"
            analyticsName="language"
            testID="PROFILE_SCREEN_LANG_FIELD"
            title={I18n.t('ProfileScreen.language')}
            rightTitle={Format.language(profile.preferred_language)}
            hideIconComponent
            tabIndex={0}
          />
          <ListItem
            key="email"
            analyticsName="email"
            testID="PROFILE_SCREEN_EMAIL_FIELD"
            title={I18n.t('ProfileScreen.email')}
            rightTitle={profile.email}
            onPress={canChangeEmail && (() => navigation.navigate('changeEmail'))}
            hideIconComponent={!canChangeEmail}
            tabIndex={0}
          />
          {(serviceFeatures.photo_id || !!idCardUrl) && (
            <ListItem
              key="photoID"
              analyticsName="photoID"
              testID="PROFILE_SCREEN_ID_FIELD"
              title={I18n.t('ProfileScreen.photoID')}
              rightTitle={
                idCardUrl
                  ? I18n.t('ProfileScreen.photoIDOnFile')
                  : I18n.t('ProfileScreen.photoIDMissing')
              }
              onPress={() => navigation.navigate('updatePhotoId')}
              tabIndex={0}
            />
          )}
        </List>
      </ResponsiveScrollView>
      <View style={Styles.brandingContainer}>
        <Cobranding />
        <DialogueBranding />
      </View>
    </NoticeBarContainer>
  )
}

export default ProfileScreen
